module.exports = __webpack_public_path__ + "assets/img/on7-ad010cca.png";